import React, { useMemo } from 'react';
import { AdvancedSearch } from 'common';
import { PRIORITY_IDS } from 'common/components/AdvancedSearch/AdvancedSearch.constants';
import { API_CLIENT_NAMES } from 'services/API';
import strings from 'strings';
import TextBox from 'UI/components/atoms/TextBox';

import { useStyles } from './CityFilter.styled';

const citiesToItems = value =>
  (value?.cities ?? []).map(c => ({ id: c.city, item: { value: c.city }, priority: c.priority }));

const itemsToCities = items => items.map(i => ({ city: i.item.value, priority: i.priority }));

const getCityOptionId = option => (typeof option === 'string' ? option : option.value);

const TYPEAHEAD_PARAMS = { limitKey: 'size', sort: 'key' };
const DEFAULT_PRIORITY = PRIORITY_IDS.CanHave;

export const CityFilter = ({
  coordinatesFieldName,
  endpoint,
  fieldName,
  groupBy,
  name,
  onChange,
  title,
  value
}) => {
  const classes = useStyles();
  const selectedItems = useMemo(() => citiesToItems(value), [value]);

  const emit = ({ cities, radius }) => {
    const hasCities = cities.length > 0;
    onChange(name, {
      fieldName,
      coordinatesFieldName,
      value: hasCities
        ? {
            cities,
            radius: radius ?? null,
            defaultPriority: DEFAULT_PRIORITY
          }
        : null
    });
  };

  return (
    <>
      <AdvancedSearch
        apiClient={API_CLIENT_NAMES.Secondary}
        defaultPriority={DEFAULT_PRIORITY}
        endpoint={endpoint}
        fieldName={fieldName}
        getOptionId={getCityOptionId}
        getOptionLabel={getCityOptionId}
        groupBy={groupBy}
        placeholder={strings.resumeSearch.filters.placeholders.cities}
        selectedItems={selectedItems}
        title={title}
        typeahead
        typeaheadLimit={25}
        typeaheadParams={TYPEAHEAD_PARAMS}
        onSelectionChange={(_field, items) =>
          emit({ cities: itemsToCities(items), radius: value?.radius ?? null })
        }
      />
      {value?.cities?.length > 0 && (
        <div className={classes.radiusContainer}>
          <TextBox
            disableDecimals
            disableNegatives
            inputType="number"
            label={strings.shared.filters.radiusAroundCity}
            name={`${name}Radius`}
            value={value.radius ?? ''}
            onChange={(_k, val) => emit({ cities: value.cities, radius: val !== '' ? val : null })}
          />
        </div>
      )}
    </>
  );
};
